/**
 * @module profile/components/portfolio/mobile_entry_details
 */
import React, { Component, PropTypes } from 'react';
import PinchView from 'common/components/pinch_view';
import PortfolioEntryInfo from 'profile/components/portfolio/portfolio_entry_info';

/**
 * Component for the portfolio single entry component for mobile devices.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class EntryDetails extends Component {

  renderImage() {
    const { entry, entryState, zoomInEntry, zoomOutEntry } = this.props;

    return (
      <PinchView
        debug={false}
        imageSize={{ width: entry.width, height: entry.height }}
        zoom={entryState.zoom}
        maxScale={entryState.maxScale}
        onZoomIn={zoomInEntry}
        onZoomOut={zoomOutEntry}
      >
        <img src={entry.image} alt={entry.title} />
      </PinchView>
    );
  }

  renderEntryDetails() {
    const { entry, userAccess, creative } = this.props;

    return (
      <section className="small-16 column entry-details">
        <div className="row">
          <PortfolioEntryInfo entry={entry} />
        </div>
        <div className="row">
          <div className="small-16 column entry-description">
            { entry.description }
          </div>
          { !userAccess.isOwner &&
            <div className="small-16 column entry-creative">
              <h4>DESIGNER</h4>
              <div className="row user-info">
                <div className="avatar avatar-square avatar-sm">
                  <img src={creative.image} alt="Creative Avatar" />
                </div>
                <span>
                  { creative.username }
                </span>
              </div>
            </div>
          }
          { userAccess.userType === 'anonymous' &&
            <div className="small-16 column work-1on1">
              <button type="button" className="btn btn-primary">
                Work 1-on-1
              </button>
            </div>
          }
        </div>
      </section>
    );
  }

  render() {
    const { userAccess, toggleEntryDetails, entry } = this.props;

    if (entry) {
      return (
        <div className="single-entry-modal">
          <div className="entry-modal-content portfolio-mobile-entry">
            <div className="entry-wrapper">
              <div className="row">
                <div className="entry-content">
                  <div className="small-16 column header">
                    <span
                      className="toggle-view"
                      onClick={toggleEntryDetails}
                    >
                      &lt; All designs
                    </span>
                  </div>
                  <section className="small-16 column entry-content full-width">
                    {this.renderImage()}
                  </section>
                  {this.renderEntryDetails()}
                  { userAccess.userType === 'anonymous' &&
                    <section className="small-16 column ready-to-start">
                      <h3 className="">Ready to get started ?</h3>
                      <span className="">
                        Creating a project like this is easy on crowdspring.
                        Get started in just a few minutes.
                      </span>
                      <button className="btn btn-secondary">
                        Start a Project Like This
                      </button>
                    </section>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

/**
 * PropTypes.
 *
 * @property {object} creative - author data object
 * @property {object} userAccess - viewing user's privileges and info
 * @property {object} entryState - object with single entry state
 * @property {object} entry - entry data object
 * @property {func} zoomInEntry - action creator to zoom-in the image
 * @property {func} zoomOutEntry - action creator to zoom-out the image
 * @property {func} toggleEntryDetails - show/hide single entry modal
 */
EntryDetails.propTypes = {
  creative: PropTypes.object,
  userAccess: PropTypes.object,
  entryState: PropTypes.object,
  entry: PropTypes.object,
  zoomInEntry: PropTypes.func,
  zoomOutEntry: PropTypes.func,
  toggleEntryDetails: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio/mobile_entry_details.jsx